/* eslint-disable no-unused-vars */
import { AnalyticsConfiguration, Facet, SortCriterion } from "@coveo/headless";

export enum PageType {
	Insights = "Dimensional Insights",
	MyDimensional = "MyDimensional",
	Search = "Search",
	Newsroom = "Newsroom"
}

export enum CoveoSearchHub {
	NewsroomBrowse = "NewsroomBrowse",
	InsightsBrowse = "InsightsBrowse",
	CoveoSearch = "CoveoSearch",
	PublicSearch = "PublicSearch"
}

// there is no apiBaseUrl property in the AnalyticsConfiguration type
// but not having this value causes console errors
export interface CoveoAnalytics extends AnalyticsConfiguration {
	apiBaseUrl: string;
}

export type CoveoHeadlessFacetName = {
	name: string;
	facetField: string;
	hide: boolean;
};

export type CoveoHeadlessSortCriteria = {
	name: string;
	criteria: string;
	isActive: boolean;
};

export type CoveoHeadlessFilters = {
	facetName: CoveoHeadlessFacetName[];
	facetShowMore?: string;
	facetsShowLess?: string;
	numberOfFacets?: number;
	pipeline: string;
	numberOfResults: string;
	searchHub: string;
	sortCriteria: CoveoHeadlessSortCriteria[];
};

type TemplateConditions = {
	field: string;
	value: string;
};

export type CoveoHeadlessTemplate = {
	conditions?: (TemplateConditions | null)[] | null;
	content: string;
};

export type CoveoHeadlessContext = {
	userType: string;
	userCountry: string;
	userEnv: string;
};

export type CoveoHeadlessTab = Record<string, { isActive: boolean; tabFacet: string }>;

export type CoveoHeadlessData = {
	filters: CoveoHeadlessFilters;
	layout: string;
	showMoreText: string;
	filterCloseText: string;
	resultDescription: string;
	fields: string[];
	tabs: CoveoHeadlessTab | {};
	aq: string;
	cq: string;
	templates: CoveoHeadlessTemplate[];
	context: CoveoHeadlessContext;
	showResults?: string;
	facetQuantifier?: string;
	noresults?: {
		text: string;
		cta: { text: string; link: string }[];
		subtext?: string;
	};
	didYouMean: {
		correctedText: string;
		suggestionsText: string;
		noResultsText: string;
	};
};

export type CoveoEngineProps = {
	dataset: {
		uniqueid: string;
		search?: boolean;
	};
	data: CoveoHeadlessData;
	pageType?: string;
};

export type SortByDictionary = {
	name: string;
	criterion: SortCriterion;
};

export const standaloneSearchBoxStorageKey = "coveo_standalone_search_box_data";

export enum CoveoHeadlessSortBy {
	Alphabetical = "@resulttitle ascending",
	PublishDateAsc = "@publishdate descending",
	PublishDateDesc = "@publishdate ascending",
	Relevancy = "relevancy"
}

export type FacetMobileProps = {
	facet: Facet;
	facetGroup: string;
	sortItems?: boolean;
	showCount?: boolean;
};
